import classNames from 'classnames';
import { memo } from 'react';
import useOrderProductGridContext from '../../../../../../contexts/OrderProductGrid.context';
import HorizontalScroll from '../../../../../components/HorizontalScroll/HorizontalScroll';
import OrderProductGridButton from '../../../buttons/components/OrderProductGridButton';
import OrderProductGrid from '../OrderProductGrid';
import { useOrderProductGridContentStyles } from './OrderProductGridContent.styles';
import { useHighlightSugestion } from './hooks/useHighlightSugestion';

export interface OrderProductGridContentProps {
  ExtraButton?: React.ReactNode;
}

const OrderProductGridContent = ({ ExtraButton }: OrderProductGridContentProps) => {
  const { classes } = useOrderProductGridContentStyles();
  const { hideButtons, highlightProduct } = useOrderProductGridContext();
  const { highlightSugestion, handleHoverSugestionButton } = useHighlightSugestion();

  return (
    <HorizontalScroll
      highlightProduct={highlightProduct}
      ExtraButton={
        ExtraButton ? (
          <div style={{ display: 'flex', flexDirection: 'column', rowGap: 4 }}>
            {!hideButtons && (
              <OrderProductGridButton handleHoverSugestionButton={handleHoverSugestionButton} />
            )}
            {ExtraButton}
          </div>
        ) : (
          !hideButtons && (
            <OrderProductGridButton handleHoverSugestionButton={handleHoverSugestionButton} />
          )
        )
      }
    >
      <div className={classNames({ [classes.highlightSugestion]: highlightSugestion })}>
        <OrderProductGrid />
      </div>
    </HorizontalScroll>
  );
};

export default memo(OrderProductGridContent);
